<template>
  <div class="wrapper">
    <div class="loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "SwitchPageLoader"
    }
</script>

<style lang="scss" scoped>

  .wrapper {
    z-index: 1;
    /*position: absolute;*/
    width: 100%;
    height: 3px;
    left: 0;
    right: 0;
    top: 0;
  }

  .loader {
    height: 100%;
    display: flex;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader div {
    flex: 1;
    background: $primary;
    -webkit-animation: go 0.8s infinite;
    animation: go 0.8s infinite;
  }

  .loader div:nth-child(1) {
    -webkit-animation-delay: -0.72s;
    animation-delay: -0.72s;
  }
  .loader div:nth-child(2) {
    -webkit-animation-delay: -0.64s;
    animation-delay: -0.64s;
  }
  .loader div:nth-child(3) {
    -webkit-animation-delay: -0.56s;
    animation-delay: -0.56s;
  }
  .loader div:nth-child(4) {
    -webkit-animation-delay: -0.48s;
    animation-delay: -0.48s;
  }
  .loader div:nth-child(5) {
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
  }
  .loader div:nth-child(6) {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  .loader div:nth-child(7) {
    -webkit-animation-delay: -0.24s;
    animation-delay: -0.24s;
  }
  .loader div:nth-child(8) {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
  .loader div:nth-child(9) {
    -webkit-animation-delay: -0.08s;
    animation-delay: -0.08s;
  }
  .loader div:nth-child(10) {
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
  }

  @-webkit-keyframes go {
    100% {
      background: transparent;
      flex: 10;
      box-shadow: 0 0 0 transparent;
    }
  }

  @keyframes go {
    100% {
      background: transparent;
      flex: 10;
      box-shadow: 0 0 0 transparent;
    }
  }

</style>



// WEBPACK FOOTER //
// src/custom/mepsaws/comp/switchPageLoader.vue